import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'cvcFilled',
  initialState: false,
  reducers: {
    setCvcFilled(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setCvcFilled } = slice.actions;

export default slice.reducer;
